export default "__VITE_ASSET__uM2ljgPB__"